// VOY-485 (rebuild) — Badges (Public profile tab).
//
// PLACEHOLDER. Gaming/badges backend not built. Style the chrome and a
// representative empty-state so the section reads "coming soon" — no
// fabricated unlocks. When the gaming layer ships, fetch the user's
// unlocked badges + total catalog count here.
//
// TODO: wire to badges backend when gaming layer ships.

const PLACEHOLDER_TILES = [
  'First flight',
  'Frequent flyer',
  'Wine country',
  'City hopper',
  'Beach week',
  'Slow traveler',
  'Local guide',
] as const

function StarIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 2l2.5 6.5L21 9l-5 4.5L17 21l-5-3-5 3 1-7.5L3 9l6.5-0.5z" />
    </svg>
  )
}

function LockIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <circle cx="12" cy="16" r="1" />
      <path d="M17 8V6a5 5 0 0 0-10 0v2" />
      <rect x="5" y="8" width="14" height="12" rx="2" />
    </svg>
  )
}

export function BadgesSection() {
  return (
    <section className="card" aria-labelledby="badges-h">
      <div className="card-h">
        <h3 id="badges-h">Badges</h3>
        <span className="meta">COMING SOON</span>
      </div>
      <div className="grid-4" style={{ gap: 10 }}>
        {PLACEHOLDER_TILES.map((label) => (
          <div key={label} className="badge-tile">
            <div className="badge-tile-icon"><StarIcon /></div>
            <div className="badge-tile-label">{label}</div>
          </div>
        ))}
        <div className="badge-tile locked">
          <div className="badge-tile-icon"><LockIcon /></div>
          <div className="badge-tile-label">Coming soon</div>
        </div>
      </div>
      <p className="placeholder-note">
        Badges arrive with the gaming layer — what you see is a preview, not your data.
      </p>
    </section>
  )
}
